import React, { useState, useEffect } from 'react';
import classNames from 'classnames';

import {
  Card,
  Form,
  Input,
  Button,
  Row,
  Col,
  Steps,
  Upload,
  message,
  Select,
  Space,
  Progress,
  notification,
  InputNumber,
  Table,
  Tooltip,
} from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import barChart from '../../../../assets/icons/bar-chart-square-02.png';
import './style.css';
import { useLocation, useNavigate } from 'react-router-dom';
import chevron_right from '../../../../assets/icons/chevron_right.png';
import step_base_icon from '../../../../assets/icons/step_base_icon.png';
import inactive_bbs from '../../../../assets/icons/inactive_bbs.png';
import pdf_image from '../../../../assets/icons/pdf_image.png';
import tick_icon from '../../../../assets/icons/tick_icon.png';
import excel_icon from '../../../../assets/icons/excel_icon.png';
import arrow_right from '../../../../assets/icons/arrow_right.png';
import button_icon from '../../../../assets/icons/button_icon.png';
import CalculatorOutlined_active from '../../../../assets/icons/CalculatorOutlined_active.png';
import * as XLSX from 'xlsx';
import { history } from '../../../../app/history';
import { saveAs } from 'file-saver';
import {
  getProjectList,
  createNewBBS,
  getBBsDetails,
  getFinalBBSOutput,
} from '../../../dashboard/redux/slice.js';
import {
  createBbsOptimise,
  createBBSAlgorithm,
  getBBSViewFiles,
  getFinalBbsSummary,
} from '@features/bbsOptimization/redux/slice';
import { useSelector, useDispatch } from 'react-redux';
import UploadFiles from '../bbsOptimizationPages/uploadFiles';
import LocalStorage from '../../../../utilities/localStorage.js';
import { optimizeAlgorithmExport } from './OptimizeAlgorithmExport';
import VisualizationTable from './VisualizationTable';
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  DeleteOutlined,
} from '@ant-design/icons';
import CustomProgress from '../../../../common/Layout/CustomProgress';
import { get } from 'lodash';
import { apiUrl } from '../../../../utilities/apiClient.js';

const { Step } = Steps;
const { Dragger } = Upload;

const BbsOptimization = () => {
  const location = useLocation();
  const { data } = location.state || {};
  const { newBBSData, getBbsData, finalBBSOutput } = useSelector(
    (state) => state.projectList,
  );
  const {
    optimiseLoading,
    bbsAlgorithmLoading,
    bbsAlgorithmResult,
    finalSummaryData,
    loading,
  } = useSelector((state) => state.bbsOptimise);
  console.log('new BBs data: ', bbsAlgorithmResult);

  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { Option } = Select;

  const [bbsCurrentStep, setBBSbbsCurrentStep] = useState(0);
  const [bbsData, setBbsData] = useState(null);
  const [stepOneData, setStepOneData] = useState({});
  const [inputFiles, setInputFiles] = useState([]);
  const [inputFilesView, setInputFilesView] = useState([]);
  const [optimizationDate, setOptimizationDate] = useState(null);
  const [isOptimizationDone, setIsOptimizationDone] = useState(false);
  const [downloading, setDownloading] = useState('');
  const [downloadingType, setDownloadingType] = useState('');
  const [downloadingIndex, setDownloadingIndex] = useState(null);

  const [progress, setProgress] = useState(0);

  const [csvProgress, setCsvProgress] = useState(0);
  const [bbsId, setBbsId] = useState(null);
  const [pdfDownloadLoading, setPdfDownloadLoading] = useState(false);
  const user_details = LocalStorage.getItem('bbs_user');
  // console.log('user details: ', user_details);
  const { step, project_code, bbs_id, files } = location.state || {};

  const weightedAverageOffcut = finalSummaryData?.Weighted_average_offcut || 0;

  // Transform API data to match table format
  const dataSource =
    finalSummaryData?.formattedData?.map((item, index) => ({
      key: index + 1,
      dia: item.rebar_dia,
      quantity: item.quantity,
      proportion: item.proportion.toFixed(2),
      offcut: item.offcut,
    })) || [];
  const totalQuantity = dataSource.reduce(
    (sum, item) => sum + (item.quantity || 0),
    0,
  );

  const columns = [
    {
      title: 'Rebar Dia (in mm)',
      dataIndex: 'dia',
      key: 'dia',
      align: 'center',
      onHeaderCell: () => ({
        style: { backgroundColor: '#1C4E9D', color: 'white' },
      }),
    },
    {
      title: 'Quantity (in MT)',
      dataIndex: 'quantity',
      key: 'quantity',
      align: 'center',
      onHeaderCell: () => ({
        style: { backgroundColor: '#1C4E9D', color: 'white' },
      }),
    },
    {
      title: 'Proportion (%)',
      dataIndex: 'proportion',
      key: 'proportion',
      align: 'center',
      onHeaderCell: () => ({
        style: { backgroundColor: '#1C4E9D', color: 'white' },
      }),
    },
    {
      title: 'Offcut (%)',
      dataIndex: 'offcut',
      key: 'offcut',
      align: 'center',
      onHeaderCell: () => ({
        style: { backgroundColor: '#1C4E9D', color: 'white' },
      }),
    },
  ];

  useEffect(() => {
    if (location.state?.step !== undefined) {
      setBBSbbsCurrentStep(location.state.step);
    }
  }, [location.state]);

  // useEffect(() => {
  //   if (bbsId) {
  //     dispatch(getFinalBbsSummary({ bbs_id: bbsId }));
  //   }
  // }, [dispatch, bbsId]);
  console.log('finalbbsSumaary data: ', finalSummaryData);

  useEffect(() => {
    const { bbs_id } = location.state || {};

    if (bbs_id) {
      dispatch(getBBsDetails({ bbs_id }))
        .then((getBbsDetailsRes) => {
          if (getBbsDetailsRes.payload?.success) {
            console.log(
              'Successfully fetched BBS details:',
              getBbsDetailsRes.payload,
            );

            setBbsData(getBbsDetailsRes.payload.data);
            const {
              is_active,
              project_name,
              project_code,
              specific_structure,
              sub_contractor_name,
              execution_agency,
              execution_duration,
            } = getBbsDetailsRes.payload.data || {};

            form.setFieldsValue({
              project_name:
                is_active === false
                  ? project_name
                  : data?.RequestApproval?.project_name,
              project_code:
                is_active === false
                  ? project_code
                  : data?.RequestApproval?.project_code,
              specific_structure:
                is_active === false ? specific_structure : null,
              sub_contractor_name:
                is_active === false ? sub_contractor_name : null,
              execution_agency: is_active === false ? execution_agency : null,
              execution_duration:
                is_active === false ? execution_duration : null,
            });
          } else {
            console.error(
              'Failed to fetch BBS details:',
              getBbsDetailsRes.payload?.message,
            );
          }
        })
        .catch((error) => {
          console.error('Error fetching BBS details:', error);
        });
    } else {
      console.error('bbs_id not found in location state');
    }
  }, [dispatch, location.state, form, data?.RequestApproval]);

  console.log('bbsData:', bbsData);

  const [isSmallScreen, setIsSmallScreen] = useState(
    () => window.innerWidth < 1200,
  );

  // Function to update the screen size state
  const handleResize = () => {
    setIsSmallScreen(window.innerWidth < 1200);
  };

  useEffect(() => {
    // Add resize event listener
    window.addEventListener('resize', handleResize);

    // Cleanup on unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const navigate = useNavigate();

  const [formData, setFormData] = useState({});
  const [fileList, setFileList] = useState([]);
  const [isUploading, setIsUploading] = useState(false);
  const [deletedFiles, setDeletedFiles] = useState([]);
  const [allExtractedData, setAllExtractedData] = useState([]);
  const [optimizedResponseData, setOptimizedResponseData] = useState([]);

  const prevStep = () => setBBSbbsCurrentStep(bbsCurrentStep - 1);

  const clearForm = () => {
    form.resetFields();
    setFormData({});
    setFileList([]);
    setDeletedFiles([]);
  };

  // const { allProjectList} = useSelector(
  //   (state) => state.projectList,
  // );
  // useEffect(() => {
  //   dispatch(getProjectList());
  // }, [dispatch]);

  // console.log("All Project list: ", allProjectList, "Type:", Array.isArray(allProjectList))
  // console.log("All Location list: ", locations, "Type:", Array.isArray(locations))

  const nextStep = () => {
    form
      .validateFields()
      .then((values) => {
        // console.log('Step 1 Data:', values);
        setStepOneData((prev) => ({
          ...prev,
          project_name: data?.project_name || prev.project_name, // Ensure autofetched data is included
          project_code: data?.project_code || prev.project_code,
          ...values,
        }));
        // console.log('Updated StepOneData:', {
        //   ...stepOneData,
        //   ...values,
        // });
        setBBSbbsCurrentStep(bbsCurrentStep + 1); // Move to Step 2
      })
      .catch((info) => {
        // console.log('Validation failed:', info);
        message.error('Please fill all required fields before proceeding.');
      });
  };

  useEffect(() => {
    let interval;

    // If either loading state is true, start progress updates
    if (optimiseLoading) {
      setProgress(0); // Reset progress at the start

      interval = setInterval(() => {
        setProgress((prevProgress) => {
          if (prevProgress >= 100) {
            clearInterval(interval); // Stop the interval once progress reaches 100
            return prevProgress;
          }
          return prevProgress + 10; // Increment progress
        });
      }, 300);
    } else {
      // Reset progress and clear interval when both loading states are false
      clearInterval(interval);
      setProgress(0);
    }

    // Cleanup interval when component unmounts or dependencies change
    return () => clearInterval(interval);
  }, [optimiseLoading]); // Dependency array includes both loading states

  // useEffect(() => {
  //   let interval;

  //   // First task progress bar (CSV generation)
  //   if (bbsAlgorithmLoading && progressTaskOne < 100) {
  //     setProgressTaskOne(50); // Set progress to 50% after CSV generation starts

  //     interval = setInterval(() => {
  //       setProgressTaskOne((prevProgress) => {
  //         if (prevProgress >= 100) {
  //           clearInterval(interval);
  //           return prevProgress;
  //         }
  //         return prevProgress + 10; // Increment by 10 or use your desired interval
  //       });
  //     }, 500);
  //   }

  //   // Second task progress bar (API processing)
  //   if (progressTaskOne >= 100 && progressTaskTwo < 100) {
  //     setProgressTaskTwo(50); // Start task two once task one is done

  //     interval = setInterval(() => {
  //       setProgressTaskTwo((prevProgress) => {
  //         if (prevProgress >= 100) {
  //           clearInterval(interval);
  //           return prevProgress;
  //         }
  //         return prevProgress + 10; // Increment by 10 or use your desired interval
  //       });
  //     }, 500);
  //   }

  //   return () => clearInterval(interval);
  // }, [bbsAlgorithmLoading, progressTaskOne, progressTaskTwo]);

  const currentDate = new Date();

  // Format the date to YYYY-MM-DD
  const formattedDate = currentDate.toISOString().split('T')[0];
  // console.log(user_details?.user?.id);
  // // Final submit function

  const submitData = async () => {
    const formData = new FormData();
    const updatedExtractData = allExtractedData.map((data) => {
      const file = fileList.find((file) => file.uid === data.fileUid);
      if (file) {
        return { ...data, fileName: file.name };
      } else {
        return data;
      }
    });
    const serializedData = JSON.stringify(updatedExtractData);
    formData.append('userId', user_details?.user?.id);
    formData.append('optimization_date', formattedDate);
    formData.append('execution_agency', stepOneData?.execution_agency || '');
    formData.append(
      'execution_duration',
      stepOneData?.execution_duration
        ? Number(stepOneData.execution_duration)
        : 0,
    );
    // formData.append('location', stepOneData?.location || '');
    //formData.append('location_id', stepOneData?.location_id || '');
    formData.append('project_code', stepOneData?.project_code || '');
    formData.append('project_name', stepOneData?.project_name || '');
    formData.append(
      'specific_structure',
      stepOneData?.specific_structure || '',
    );
    formData.append(
      'sub_contractor_name',
      stepOneData?.sub_contractor_name || '',
    );

    formData.append('data', serializedData);

    if (!fileList || fileList.length === 0) {
      message.error('Please upload at least one file.');
      return;
    }

    // Append files with their original filenames
    fileList.forEach((file) => {
      formData.append('files', file.originFileObj, file.name);
    });
    for (let [key, value] of formData.entries()) {
      console.log(key, value);
    }
    try {
      dispatch(createBbsOptimise.pending());

      await new Promise((resolve) => setTimeout(resolve, 300));
      const response = await dispatch(createBbsOptimise(formData)).unwrap();
      console.log('responsewer: ', response);
      if (response?.success) {
        const { uploadedFiles, bbs } = response;
        setOptimizedResponseData(bbs);
        setInputFiles(Array.isArray(uploadedFiles) ? uploadedFiles : []);
        console.log('Optimized Response Data:', response);
        const bbsId = bbs?.bbs_id;
        if (bbsId) {
          console.log('BBS ID:', bbsId);
          setBbsId(bbsId); // Save the bbs_id
        }
      }

      if (
        response?.message?.trim() ===
        'Uploaded files, consolidated successfully'
      ) {
        message.success(response?.message);
        setBBSbbsCurrentStep(bbsCurrentStep + 1);
        console.log('Finally the data is : ', allExtractedData);
      } else {
        message.error(response?.message || 'Submission failed');
        //setBBSbbsCurrentStep(bbsCurrentStep + 1);
      }
    } catch (error) {
      console.error('Error during submission:', error);
      message.error('An unexpected error occurred.');
    } finally {
      dispatch(createBbsOptimise.fulfilled()); // Set optimiseLoading to false
    }
  };

  // const downloadExcelFile = (
  //   data,
  //   uploadedFiles = [],
  //   fileName = 'consolidated_data.xlsx',
  // ) => {
  //   if (!data || data.length === 0) {
  //     alert('No data available to download.');
  //     return;
  //   }

  //   // Ensure uploadedFiles is an array
  //   if (!Array.isArray(uploadedFiles)) {
  //     console.error('uploadedFiles should be an array');
  //     return;
  //   }

  //   // Create a new data array with fileUid excluded and original file name added
  //   const modifiedData = data.map((item) => {
  //     const { fileUid, ...rest } = item; // Destructure and exclude fileUid

  //     // Use fileName directly from item
  //     const originalFileName = item.fileName || 'Unknown File';

  //     return {
  //       fileName: originalFileName, // Place FileName as the first property
  //       ...rest, // Spread the rest of the properties after FileName
  //     };
  //   });

  //   // Capitalize the column headers
  //   const capitalizeHeaders = (headers) => {
  //     return headers.map((header) => {
  //       return header.charAt(0).toUpperCase() + header.slice(1);
  //     });
  //   };

  //   // Get the headers from the modified data (FileName will be the first column)
  //   const headers = Object.keys(modifiedData[0]);
  //   const capitalizedHeaders = capitalizeHeaders(headers);

  //   // Prepare data for the sheet (use capitalized headers)
  //   const sheetData = modifiedData.map((item) => {
  //     const capitalizedItem = {};
  //     Object.keys(item).forEach((key) => {
  //       const capitalizedKey = key.charAt(0).toUpperCase() + key.slice(1);
  //       capitalizedItem[capitalizedKey] = item[key];
  //     });
  //     return capitalizedItem;
  //   });

  //   const worksheet = XLSX.utils.json_to_sheet(sheetData, {
  //     header: capitalizedHeaders,
  //   });
  //   const workbook = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(workbook, worksheet, 'Consolidated Data');
  //   XLSX.writeFile(workbook, fileName);
  // };

  const [modifiedData, setModifiedData] = useState([]);

  // const handleBbsClick = (bbs, projectCode, type) => {

  //   const params = {
  //     bbsId: bbs,
  //     project_code: projectCode,
  //     type,
  //   };
  //   dispatch(getBBSViewFiles(params))
  //     .then((res) => {
  //       if (res.payload?.success) {
  //         const { formattedData } = res.payload;
  //         handleDownload(formattedData, bbs);
  //       } else {
  //         console.error('Backend response does not indicate success.');
  //       }
  //     })
  //     .catch((error) => {
  //       console.error('Error fetching BBS view files:', error);
  //     });
  // };

  const handleBbsClick = async (bbs, projectCode, type) => {
    setDownloading(type); // Start loader
    const params = {
      bbsId: bbs,
      project_code: projectCode,
      type,
    };

    try {
      const res = await dispatch(getBBSViewFiles(params));
      if (res.payload?.success) {
        const { formattedData } = res.payload;
        handleDownload(formattedData, bbs);
      } else {
        console.error('Backend response does not indicate success.');
      }
    } catch (error) {
      console.error('Error fetching BBS view files:', error);
    } finally {
      setDownloading('');
    }
  };

  const downloadFinalBBSSummary = async (bbs) => {
    try {
      const response = await fetch(`${apiUrl}/bbs/output-file?bbs_id=${bbs}`, {
        method: 'GET',
        headers: {
          'Content-Type':
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // Optional
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      // Create a temporary anchor element
      const a = document.createElement('a');
      a.href = url;
      a.download = `${bbs}_Final BBS Summary.xlsx`; // Adjust the file name as needed
      document.body.appendChild(a);
      a.click();

      // Cleanup
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch (error) {
      console.error('Error downloading the file:', error);
    }
  };

  const downloadMappingSheet = async (bbs) => {
    try {
      const response = await fetch(`${apiUrl}/bbs/mapping-file?bbs_id=${bbs}`, {
        method: 'GET',
        headers: {
          'Content-Type':
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // Optional
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      // Create a temporary anchor element
      const a = document.createElement('a');
      a.href = url;
      a.download = `${bbs}_Mapping Sheet.xlsx`; // Adjust the file name as needed
      document.body.appendChild(a);
      a.click();

      // Cleanup
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch (error) {
      console.error('Error downloading the file:', error);
    }
  };

  // const handleBbsSummary=(bbs) => {
  //   const params = {
  //     bbs_id: bbs,
  //   };
  //   dispatch(getFinalBBSOutput(params))
  //     .then((res) => {
  //       if (res.payload?.success) {
  //        message.success(res.payload.message)
  //       } else {
  //         console.error('Backend response does not indicate success.');
  //       }
  //     })
  //     .catch((error) => {
  //       console.error('Error fetching final Bbs summary files:', error);
  //     });
  // };

  const handleDownload = (formattedData, bbs) => {
    if (!formattedData || formattedData.length === 0) {
      console.error('No data to download.');
      return;
    }

    console.log('Formatted Data Passed to Download:', formattedData);

    // Create a worksheet from the data
    const worksheet = XLSX.utils.json_to_sheet(formattedData);

    // Create a new workbook and append the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Consolidated Data');

    // Trigger download of the workbook
    XLSX.writeFile(workbook, `${bbs}_Consolidated Data.xlsx`);
  };

  const downloadExcelFile = (
    data,
    uploadedFiles = [],
    fileName = 'consolidated_data.xlsx',
    sheetNames = [],
  ) => {
    if (!data || data?.length === 0) {
      alert('No data available to download.');
      return;
    }

    // Ensure uploadedFiles is an array
    if (!Array.isArray(uploadedFiles)) {
      console.error('uploadedFiles should be an array');
      return;
    }

    // Create a new data array with fileUid excluded and original file name added
    const modifiedData = data?.map((item) => {
      const { fileUid, ...rest } = item; // Destructure and exclude fileUid

      // Use fileName directly from item
      const originalFileName = item.fileName || 'Unknown File';

      return {
        fileName: originalFileName, // Place FileName as the first property
        sheetName: item.sheetName || 'Unknown Sheet', // Add sheetName to the data
        ...rest, // Spread the rest of the properties after FileName
      };
    });

    // Capitalize the column headers
    const capitalizeHeaders = (headers) => {
      return headers?.map((header) => {
        return header.charAt(0).toUpperCase() + header.slice(1);
      });
    };

    // Get the headers from the modified data (FileName will be the first column)
    const headers = Object.keys(modifiedData[0]);
    const capitalizedHeaders = capitalizeHeaders(headers);

    // Prepare data for the sheet (use capitalized headers)
    const sheetData = modifiedData?.map((item) => {
      const capitalizedItem = {};
      Object?.keys(item)?.forEach((key) => {
        const capitalizedKey = key?.charAt(0)?.toUpperCase() + key?.slice(1);
        capitalizedItem[capitalizedKey] = item[key];
      });
      return capitalizedItem;
    });

    const worksheet = XLSX.utils.json_to_sheet(sheetData, {
      header: capitalizedHeaders,
    });
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Consolidated Data');
    XLSX.writeFile(workbook, fileName);
  };

  //------Raw Optimized data----------------------
  const downloadCSVFile = (data, fileName = 'data_to_send.csv') => {
    if (!data || data?.length === 0) {
      console.error(
        'Data passed to downloadCSVFile is invalid or empty:',
        data,
      );
      alert('No data available to download.');
      return null; // Return null to indicate failure
    }

    // Map for renaming headers
    const renamedHeadersMap = {
      diameter: 'Rebar Dia',
      cutLength: 'Cut length',
      numberOfBars: 'Qty',
    };

    // Desired column order
    const columnOrder = ['Rebar Dia', 'Cut length', 'Qty'];

    // Create a new data array with fileUid excluded and renamed headers
    const modifiedData = data?.map((item) => {
      const { fileUid, fileName, sheetName, ...rest } = item; // Exclude fileUid, fileName, and sheetName
      const renamedItem = {};

      // Rename headers based on renamedHeadersMap
      Object.keys(rest)?.forEach((key) => {
        const renamedKey = renamedHeadersMap[key] || key;
        renamedItem[renamedKey] = rest[key];
      });

      return renamedItem;
    });

    // Capitalize the column headers
    const capitalizeHeaders = (headers) =>
      headers?.map(
        (header) => header.charAt(0).toUpperCase() + header.slice(1),
      );

    // Use the desired column order for headers
    const capitalizedHeaders = capitalizeHeaders(columnOrder);

    // Map data to CSV rows with specified column order
    const csvRows = modifiedData?.map((item) => {
      return columnOrder?.map((header) => `"${item[header] || ''}"`).join(',');
    });

    // Combine headers and rows to form CSV content
    const csvContent = [capitalizedHeaders.join(','), ...csvRows].join('\n');

    console.log('CSV Content:', csvContent);

    // Create a Blob from CSV content
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

    // Return the File object
    return new File([blob], fileName, { type: 'text/csv' });
  };

  useEffect(() => {
    let interval;

    if (bbsAlgorithmLoading) {
      setCsvProgress(0); // Reset progress at the start
      interval = setInterval(() => {
        setCsvProgress((prevProgress) => {
          if (prevProgress >= 100) {
            clearInterval(interval);
            return prevProgress;
          }
          return prevProgress + 10;
        });
      }, 500);
    } else {
      clearInterval(interval);
      setCsvProgress(0); // Reset on completion
    }

    return () => clearInterval(interval);
  }, [bbsAlgorithmLoading]);

  //HANDLE CSV FUNCTION WITH LOADER:

  // const handleCsvFileForAlgorithm = () => {
  //   if (!optimizedResponseData?.bbs_id || !stepOneData?.project_code) {
  //     alert('Missing required data for generating CSV.');
  //     return;
  //   }

  //   // Call downloadCSVFile to get the File object
  //   const csvFile = downloadCSVFile(allExtractedData); // Replace `dataToSend` with your actual data source
  //   console.log('CSV File:', csvFile);
  //   if (!csvFile) {
  //     console.error('Failed to generate CSV file.');
  //     return;
  //   }

  //   const formData = new FormData();
  //   formData.append('bbs_id', optimizedResponseData.bbs_id);
  //   formData.append('project_code', stepOneData.project_code);
  //   formData.append('csvFile', csvFile);

  //   // Dispatch the action to send the form data
  //   dispatch(createBBSAlgorithm(formData)).then((response) => {
  //     if (
  //       response?.payload?.success &&
  //       response?.payload?.results?.length > 0
  //     ) {
  //       setBBSbbsCurrentStep(bbsCurrentStep + 1);
  //     } else {
  //       console.error('Algorithm failed:', response?.message);
  //     }
  //   });
  // };

  //NORMAL HANDLE CSV FUNTION:

  const handleCsvFileForAlgorithm = async () => {
    if (!optimizedResponseData?.bbs_id || !stepOneData?.project_code) {
      alert('Missing required data for generating CSV.');
      return;
    }

    const csvFile = downloadCSVFile(allExtractedData);
    if (!csvFile) {
      console.error('Failed to generate CSV file.');
      return;
    }

    const formData = new FormData();
    formData.append('type', 'raw');
    formData.append('bbs_id', optimizedResponseData.bbs_id);
    formData.append('project_code', stepOneData.project_code);
    //formData.append('csvFile', csvFile);

    try {
      const response = await dispatch(createBBSAlgorithm(formData)).unwrap();
      if (response?.success && response?.results?.length > 0) {
        const { files } = response;
        setInputFilesView(Array.isArray(files) ? files : []);
        console.log('files after running api', files);
        setBBSbbsCurrentStep(bbsCurrentStep + 1);
        setOptimizationDate(response.optimization_date);

        dispatch(
          getFinalBbsSummary({
            bbs_id: optimizedResponseData.bbs_id || bbsData?.bbs_id,
          }),
        );
        setIsOptimizationDone(true);
      } else {
        console.error(
          'Algorithm failed:',
          response?.message || 'Unknown error',
        );
      }
    } catch (error) {
      console.error(
        'Error during submission:',
        error.message || 'Unknown error',
      );
    }
  };

  // const handle_PdfDownload_cuttingPattern = async () => {
  //   setPdfDownloadLoading(true);
  //   const Url = process.env.REACT_APP_API_URL;
  //   const apiUrl = `${Url}/pdf/download`;

  //   const payload = {
  //     bbs_id: optimizedResponseData.bbs_id,
  //     project_code: stepOneData.project_code,
  //   };
  //   console.log('hree inside the pdfdownload: ', payload);
  //   try {
  //     const response = await fetch(apiUrl, {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //       },
  //       body: JSON.stringify(payload),
  //     });

  //     if (!response.ok) {
  //       throw new Error('Failed to download PDF');
  //     }

  //     const blob = await response.blob();
  //     const url = window.URL.createObjectURL(blob);

  //     // Create a temporary link element for downloading
  //     const link = document.createElement('a');
  //     link.href = url;
  //     link.download = 'downloaded_file.pdf'; // Set the default file name
  //     document.body.appendChild(link);
  //     link.click();

  //     // Clean up
  //     link.remove();
  //     window.URL.revokeObjectURL(url);
  //     setPdfDownloadLoading(false);
  //     message.success('PDF downloaded successfully.');
  //   } catch (error) {
  //     setPdfDownloadLoading(false);
  //     message.error('Failed to download PDF');
  //     console.error('Error downloading PDF:', error);
  //   }
  // };

  //-------------------------

  const handle_PdfDownload_cuttingPattern = async () => {
    setPdfDownloadLoading(true);
    const Url = process.env.REACT_APP_API_URL;

    // Create URL with parameters
    const params = new URLSearchParams({
      bbs_id: optimizedResponseData.bbs_id || bbsData?.bbs_id,
      project_code: stepOneData.project_code || bbsData?.project_code,
    });
    const apiUrl = `${Url}/pdf/download?${params}`;

    console.log('here inside the pdfdownload: ', {
      bbs_id: optimizedResponseData.bbs_id,
      project_code: stepOneData.project_code,
    });

    try {
      const response = await fetch(apiUrl, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('Failed to download PDF');
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      // Create a temporary link element for downloading
      const link = document.createElement('a');
      link.href = url;
      link.download = `${optimizedResponseData.bbs_id || bbsData?.bbs_id}_Cutting Pattern.pdf`;
      document.body.appendChild(link);
      link.click();

      // Clean up
      link.remove();
      window.URL.revokeObjectURL(url);
      setPdfDownloadLoading(false);
      message.success('Cutting pattern downloaded successfully');
    } catch (error) {
      setPdfDownloadLoading(false);
      message.error('Failed to download PDF');
      console.error('Error downloading PDF:', error);
    }
  };

  const downloadInputFiles = async (blobName, fullFilename,index) => {
    setDownloadingIndex(index);
    try {
      const token = localStorage.getItem('token');
      console.log('token received: ', token);

      const response = await fetch(
        `${apiUrl}/bbs/input-files?blobName=${blobName}`,
        {
          method: 'GET',
          headers: {
            'Content-Type':
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // Optional
            // Authorization: `Bearer ${token}`, // Add Authorization token
          },
        },
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      // Create a temporary anchor element
      const a = document.createElement('a');
      a.href = url;
      a.download = `${fullFilename}`; // Adjust the file name as needed
      document.body.appendChild(a);
      a.click();

      // Cleanup
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch (error) {
      console.error('Error downloading the file:', error);
    } finally {
      setDownloadingIndex(null);
    }
  };
  console.log('project_name: ', getBbsData?.data?.project_name);
  const steps = [
    {
      title: <div className="step-title">Update BBS Details</div>,
      content: (
        <Form
          form={form}
          layout="vertical"
          enctype="multipart/form-data"
          initialValues={{
            project_name: data?.RequestApproval?.project_name,
            project_code: data?.RequestApproval?.project_code,
          }}
        >
          <Row gutter={[16, 16]}>
            <Col lg={8} xs={24} sm={12}>
              <Form.Item
                label="Project Code"
                name="project_code" // Bind to form
              >
                <Input placeholder="Enter project code" disabled />
              </Form.Item>
            </Col>
            <Col lg={8} xs={24} sm={12}>
              <Form.Item label="Project Name" name="project_name">
                <Input placeholder="Enter project name" disabled />
              </Form.Item>
            </Col>

            <Col lg={8} xs={24} sm={12}>
              <Form.Item
                label="Structure Name"
                name="specific_structure"
                rules={[
                  { required: true, message: 'Enter specific structure' },
                ]}
              >
                <Input placeholder="Enter structure name" />
              </Form.Item>
            </Col>
            <Col lg={8} xs={24} sm={12}>
              <Form.Item
                label=" Expected Execution Duration (in days)"
                name="execution_duration"
                rules={[
                  {
                    required: true, // Make the field required
                    message: 'only numbers are allowed!', // Custom required message
                  },
                  {
                    validator: (_, value) => {
                      // Check if the value is not a number
                      if (value && isNaN(value)) {
                        return Promise.reject(
                          new Error('Only numbers are allowed!'),
                        );
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <InputNumber
                  min={0}
                  step="0.1"
                  type="number"
                  placeholder="Enter expected duration"
                  style={{ width: '100%' }}
                />
              </Form.Item>
            </Col>
            <Col lg={8} xs={24} sm={12}>
              <Form.Item
                label={' Proposed Execution Philosophy'}
                name="execution_agency"
                rules={[
                  {
                    required: true,
                    message: 'Please select execution philosophy',
                  },
                ]}
              >
                <Select placeholder="Select proposed execution philosophy">
                  <Select.Option value="Cut & Bend Purchase">
                    Cut & Bend Purchase
                  </Select.Option>
                  <Select.Option value="On-site fabrication">
                    On-site fabrication
                  </Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col lg={8} xs={24} sm={12}>
              <Form.Item
                label="Sub-Contractor Name"
                name="sub_contractor_name"
                rules={[{ message: 'Please enter Sub Contractor Name' }]}
              >
                <Input placeholder="Enter sub-contractor name" />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      ),
    },
    {
      title: <div className="step-title ">Upload Files</div>,
      content: (
        <UploadFiles
          fileList={fileList}
          setFileList={setFileList}
          allExtractedData={allExtractedData}
          setAllExtractedData={setAllExtractedData}
          setIsUploading={setIsUploading}
        />
      ),
    },
    {
      title: <div className="step-title">Optimization</div>,
      content: (
        <>
          <div className="project-output">
            <Form layout="vertical">
              <div className="flex flex-col gap-4 xl:mt-8 xl:flex xl:flex-row xl:gap-2">
                <div
                  onClick={() =>
                    handleBbsClick(
                      optimizedResponseData?.bbs_id,
                      optimizedResponseData?.project_code,
                      'consolidated-data',
                    )
                  }
                  className={`cursor-pointer w-full flex gap-4 pt-[10px] pl-[10px] pb-[10px] pr-[10px] border-[1px] rounded border-[#EAECF0] h-[63px] items-center ${
                    downloading === 'consolidated-data'
                      ? 'opacity-50 pointer-events-none'
                      : ''
                  }`}
                >
                  <img
                    className="h-[30px] w-[30px]"
                    src={excel_icon}
                    alt="excel"
                  />
                  <div>
                    <p className="text-[#344054] text-[14px] font-medium">
                      {downloading === 'consolidated-data'
                        ? 'Downloading...'
                        : 'Consolidated Data'}
                    </p>
                  </div>
                  <img
                    //onClick={() => downloadExcelFile(allExtractedData)}
                    className=" ml-auto  mt-2 h-[24px] w-[24px]"
                    src={button_icon}
                  ></img>
                </div>
                {/* <div className="w-[274px] flex gap-4 pt-[10px] pl-[10px] pb-[10px] pr-[10px] border-[1px] rounded border-[#EAECF0]">
                  <img className="h-[30px] w-[30px]" src={excel_icon}></img>
                  <div>
                    <p className="text-[#344054] font-['SF-Pro-Text-Regular, sans-serif'] text-[14px]">
                      Raw Optimized file
                    </p>
                  </div>
                  <img
                    className="cursor-pointer ml-5 mt-2 h-[24px] w-[24px]"
                    src={button_icon}
                  ></img>
                </div>
                <div className="flex w-[274px] gap-4 pt-[10px] pl-[10px] pb-[10px] pr-[10px] border-[1px] rounded border-[#EAECF0]">
                  <img className="h-[30px] w-[30px]" src={excel_icon}></img>
                  <div>
                    <p className="text-[#344054] font-['SF-Pro-Text-Regular, sans-serif'] text-[14px]">
                      Final BBS Summary
                    </p>
                  </div>
                  <img
                    className="cursor-pointer ml-5 mt-2 h-[24px] w-[24px]"
                    src={button_icon}
                  ></img>
                </div> */}
              </div>
            </Form>
          </div>
        </>
      ),
    },
    {
      title: (
        <div
          onClick={() => {
            if (bbsCurrentStep >= 4) setBBSbbsCurrentStep(3);
          }}
          className="cursor-pointer step-title"
        >
          Visualization & Mapping Sheet
        </div>
      ),
      content: (
        <>
          <div className="project-output">
            {files && files.length > 0 ? (
              <ul className="flex gap-2">
                {files.map((file, index) => {
                  try {
                    const parsedFile =
                      typeof file === 'string' ? JSON.parse(file) : file;
                    const blobName = parsedFile.uploadedUrl;
                    const fullFilename =
                      parsedFile.originalName ||
                      parsedFile.filename ||
                      'Unknown File';
                    const isDownloading = downloadingIndex === index;
                    const truncatedFilename =
                      fullFilename.length > 12
                        ? `${fullFilename.substring(0, 12)}...`
                        : fullFilename;

                    return (
                      <li key={index}>
                        <div
                          onClick={() =>
                            downloadInputFiles(blobName, fullFilename,index)
                          }
                          className={`cursor-pointer w-[219px] flex gap-4 p-[10px] border-[1px] border-[#EAECF0] rounded h-[47px] items-center ${
                            isDownloading
                              ? 'opacity-50 pointer-events-none'
                              : ''
                          }`}
                        >
                          <img
                            className="h-[20px] w-[20px]"
                            src={excel_icon}
                            alt="Excel Icon"
                          />
                          <p
                            className="text-[#344054] text-[11px] font-medium truncate"
                            title={fullFilename}
                          >
                            {isDownloading
                              ? 'Downloading...'
                              : truncatedFilename}
                          </p>
                          <img
                            className="cursor-pointer ml-5 mt-2 h-[18px] w-[18px]"
                            src={button_icon}
                            alt="Button Icon"
                          />
                        </div>
                      </li>
                    );
                  } catch (error) {
                    console.error('Error parsing file:', error);
                    return null;
                  }
                })}
              </ul>
            ) : null}
            {inputFilesView?.length > 0 ? (
              <ul className="flex gap-2">
                {inputFilesView.map((file, index) => {
                  try {
                    const parsedFile =
                      typeof file === 'string' ? JSON.parse(file) : file;
                    const blobName = parsedFile.uploadedUrl;
                    const fullFilename =
                      parsedFile.originalName ||
                      parsedFile.filename ||
                      'Unknown File';
                    const isDownloading = downloadingIndex === index;
                    const truncatedFilename =
                      fullFilename.length > 12
                        ? `${fullFilename.substring(0, 12)}...`
                        : fullFilename;

                    return (
                      <li key={index}>
                        <div
                          onClick={() =>
                            downloadInputFiles(blobName, fullFilename,index)
                          }
                          className={`cursor-pointer w-[219px] flex gap-4 p-[10px] border-[1px] border-[#EAECF0] rounded h-[47px] items-center ${
                            isDownloading
                              ? 'opacity-50 pointer-events-none'
                              : ''
                          }`}
                        >
                          <img
                            className="h-[20px] w-[20px]"
                            src={excel_icon}
                            alt="Excel Icon"
                          />
                          <p
                            className="text-[#344054] text-[11px] font-medium truncate"
                            title={fullFilename}
                          >
                            {isDownloading
                              ? 'Downloading...'
                              : truncatedFilename}
                          </p>
                          <img
                            className=" ml-5 mt-2 h-[18px] w-[18px]"
                            src={button_icon}
                            alt="Button Icon"
                          />
                        </div>
                      </li>
                    );
                  } catch (error) {
                    console.error('Error parsing file:', error);
                    return null;
                  }
                })}
              </ul>
            ) : null}
            <div className="flex flex-col gap-4 mt-0 mapping-files xl:mt-3 xl:flex xl:flex-row xl:gap-2 ">
              {[
                {
                  text: 'Consolidated Data',
                  key: 'consolidated-data',
                  onClick: async () => {
                    setDownloadingType('consolidated-data');
                    await handleBbsClick(
                      optimizedResponseData?.bbs_id || bbsData?.bbs_id,
                      optimizedResponseData?.project_code ||
                        bbsData?.project_code,
                      'consolidated-data',
                    );
                    setDownloadingType('');
                  },
                },
                {
                  text: 'Raw Optimized Data',
                  key: 'raw-data',
                  onClick: async () => {
                    setDownloadingType('raw-data');

                    // Simulate async operation using setTimeout
                    await new Promise((resolve) => {
                      setTimeout(() => {
                        optimizeAlgorithmExport(
                          bbsAlgorithmResult,
                          optimizedResponseData?.bbs_id || bbsData?.bbs_id,
                        );
                        resolve(); // resolve after export is done
                      }, 300); // short delay to allow UI update
                    });

                    setDownloadingType('');
                  },
                },
                {
                  text: 'Final BBS Summary',
                  key: 'final',
                  onClick: async () => {
                    setDownloadingType('final');
                    await downloadFinalBBSSummary(
                      optimizedResponseData?.bbs_id || bbsData?.bbs_id,
                    );
                    setDownloadingType('');
                  },
                },
              ]?.map((item, index) => {
                const isDownloading = downloadingType === item.key;
                return (
                  <div
                    onClick={isDownloading ? null : item.onClick}
                    key={index}
                    className={`cursor-pointer w-[200px] flex gap-4 p-[10px] border-[1px] border-[#EAECF0] rounded h-[47px] items-center ${
                      isDownloading ? 'opacity-50 pointer-events-none' : ''
                    }`}
                  >
                    <img className="h-[20px] w-[20px]" src={excel_icon} />
                    <p className="text-[#344054] text-[11px] font-medium">
                      {isDownloading ? 'Downloading...' : item.text}
                    </p>
                    <img
                      className="ml-5 mt-2 h-[18px] w-[18px]"
                      src={button_icon}
                    />
                  </div>
                );
              })}
            </div>
            <div className="flex justify-end mt-5 mb-8">
              <Button
                className="custom-vis-btn text-[#344054] font-['SF-Pro-Text-Regular, sans-serif'] text-[14px]"
                onClick={() => handle_PdfDownload_cuttingPattern()}
                loading={pdfDownloadLoading}
              >
                <img src={pdf_image} alt="PDF" className="mr-2" />
                Download cutting pattern
              </Button>
            </div>

            <Form layout="vertical"></Form>
          </div>
        </>
      ),
    },

    {
      title: (
        <div
          onClick={() => {
            if (bbsCurrentStep >= 3) setBBSbbsCurrentStep(4);
          }}
          className="cursor-pointer step-title"
        >
          Optimization Summary
        </div>
      ),
      content: (
        <>
          <div className="project-output">
            <Form layout="vertical">
              <div className="p-6 bg-gray-100 rounded-lg">
                <h2 className="mb-4 text-xl font-bold text-center">
                  Optimization Summary
                </h2>

                <Table
                  dataSource={dataSource}
                  columns={columns}
                  bordered
                  pagination={false}
                  className="overflow-hidden rounded-lg shadow-md"
                  loading={loading}
                />

                <Card className="mt-6 bg-[#FFFFFF] text-white text-center rounded-lg shadow-md p-4 h-auto">
                  <div className="flex flex-col items-center gap-4 py-2">
                    {/* Weighted Average Offcut */}

                    <div className="w-full">
                      <h3 className="text-base font-semibold text-[#1C4E9D]">
                        Total Quantity Processed (in MT):
                      </h3>
                      <p className="text-xl font-bold text-[#1C4E9D]">
                        {totalQuantity.toFixed(2)}
                      </p>
                    </div>
                    <div className="w-full">
                      <h3 className="text-base font-semibold text-[#1C4E9D]">
                        Weighted Average Offcut (%):
                      </h3>
                      <p className="text-xl font-bold text-[#1C4E9D]">
                        {weightedAverageOffcut?.toFixed(2)}
                      </p>
                    </div>

                    {/* Border Divider */}

                    {/* Total Quantity Processed */}
                  </div>
                </Card>
              </div>
            </Form>
          </div>
        </>
      ),
    },
  ];

  return (
    <div className="main-div">
      <div className="barchart-text">
        <img src={CalculatorOutlined_active} alt="Bar Chart" />
        <p>BBS Optimization</p>
        {bbsId && (
          <>
            <img src={arrow_right} alt="arrow right" />
            <p className="text-[#1C4E9D]">{bbsId}</p>
          </>
        )}
      </div>
      <div className="w-full">
        <Row gutter={[16, 16]}>
          <div className="w-1/3 form-stepper-container">
            <Col lg={6} md={8} sm={24} xs={24}>
              <div className="steps_parent">
                <Steps
                  className="steps_track"
                  current={bbsCurrentStep}
                  labelPlacement="vertical"
                  direction="vertical"
                >
                  {steps?.map((item, index) => (
                    <Step
                      key={index}
                      status={
                        index < bbsCurrentStep
                          ? 'finish'
                          : index === bbsCurrentStep
                            ? 'process'
                            : 'wait'
                      }
                      icon={
                        index < bbsCurrentStep ? (
                          <img
                            src={tick_icon}
                            alt="Completed Icon"
                            className="step-icon"
                          />
                        ) : index === bbsCurrentStep ? (
                          <img
                            src={step_base_icon}
                            alt="Current Step Icon"
                            className="step-icon"
                          />
                        ) : (
                          <img
                            src={inactive_bbs}
                            alt="Inactive Icon"
                            className="step-icon"
                          />
                        )
                      }
                      title={
                        <div
                          className={
                            index === bbsCurrentStep && !isSmallScreen
                              ? 'ant-steps-item-active ' // Apply only for the current step on large screens
                              : 'step-title' // Apply for all steps or small screens
                          }
                        >
                          {item.title}
                        </div>
                      }
                    />
                  ))}
                </Steps>
              </div>
            </Col>

            <Col lg={18}>
              <div className="step-card-bbs_optimization ">
                <div className="flex flex-col steps_content_parent_bbs_optimization">
                  {/* {bbsCurrentStep === 2 && (
                  <>
                    <div className="flex justify-end mb-4 space-x-2">
                      <button
                        onClick={() => downloadExcelFile(allExtractedData)}
                        className="px-[16px] py-[10px] font-[SF-Pro-Text-Regular, sans-serif] text-[13px]  md:w-[206px] bg-[#FFFFFF] text-[#344054] rounded-[8px]"
                      >
                        Download consolidate file
                      </button>
                      <button className="font-[SF-Pro-Text-Regular, sans-serif] text-[13px] md:w-[206px] px-4 py-2 bg-[#FFFFFF] text-[#344054] rounded-[8px]">
                        Download raw optimized data
                      </button>
                    </div>
                  </>
                )} */}

                  <Card>
                    <div className="steps-content">
                      {steps[bbsCurrentStep] ? (
                        steps[bbsCurrentStep].content
                      ) : (
                        <div>No content available</div>
                      )}
                    </div>
                    <div className="text-center steps-action">
                      {bbsCurrentStep === 0 && (
                        <>
                          <Button
                            style={{ margin: '0 8px' }}
                            onClick={() => navigate('/dashboard')}
                            className="prev-button"
                          >
                            Back to Dashboard
                          </Button>
                          <Button
                            type="primary"
                            onClick={nextStep}
                            className="next-button"
                          >
                            Next
                          </Button>
                        </>
                      )}

                      {bbsCurrentStep === 1 && (
                        <>
                          <Button
                            style={{ margin: '0 8px' }}
                            onClick={prevStep}
                            className="prev-button"
                          >
                            Back
                          </Button>
                          <input
                            type="file"
                            id="file-upload"
                            accept=".xlsx,.xls"
                            style={{ display: 'none' }}
                          />
                          <Button
                            loading={optimiseLoading}
                            style={{ margin: '0 8px' }}
                            type="primary"
                            className="next-button"
                            onClick={submitData}
                            disabled={isUploading || fileList?.length === 0}
                          >
                            Consolidate
                          </Button>
                        </>
                      )}
                      {optimiseLoading && (
                        <>
                          {/* Semi-transparent overlay */}
                          <div
                            style={{
                              position: 'fixed',
                              top: 0,
                              left: 0,
                              width: '100%',
                              height: '100%',
                              backgroundColor: 'rgba(0, 0, 0, 0.5)', // Semi-transparent black
                              zIndex: 9998, // Lower than the progress bar container
                            }}
                          ></div>

                          {/* Progress Bar at the Center */}
                          <div
                            style={{
                              position: 'fixed',
                              top: '50%',
                              left: '50%',
                              transform: 'translate(-50%, -50%)', // Centering the div
                              backgroundColor: '#FFFFFF',
                              zIndex: 9999, // Higher than the overlay
                              textAlign: 'center',
                              padding: '20px',
                              borderRadius: '8px',
                              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                            }}
                          >
                            <Progress
                              percent={progress}
                              status={progress < 100 ? 'active' : 'success'}
                              strokeColor="#1C4E9D"
                              style={{ width: '100%' }} // Full width inside the container
                            />
                            <p
                              style={{
                                margin: '10px 0 0',
                                color: '#1C4E9D',
                                fontSize: '16px',
                              }}
                            >
                              Uploading...
                            </p>
                            <p
                              style={{
                                marginTop: '5px',
                                color: '#344054',
                                fontSize: '14px',
                              }}
                            >
                              Files are getting consolidated...
                            </p>
                          </div>
                        </>
                      )}

                      {bbsCurrentStep === 2 && (
                        <>
                          <div className="final-buttons">
                            {/* <Button
                              style={{ margin: '0 8px' }}
                              onClick={() => navigate('/dashboard')}
                              className="prev-button"
                            >
                              Back to Dashboard
                            </Button> */}
                            <Button
                              loading={bbsAlgorithmLoading}
                              type="primary"
                              onClick={() => handleCsvFileForAlgorithm()}
                              className="next-button"
                            >
                              Optimise
                            </Button>
                          </div>
                        </>
                      )}
                      {bbsAlgorithmLoading && (
                        <>
                          {/* Semi-transparent overlay */}
                          <div
                            style={{
                              position: 'fixed',
                              top: 0,
                              left: 0,
                              width: '100%',
                              height: '100%',
                              backgroundColor: 'rgba(0, 0, 0, 0.5)',
                              zIndex: 9998,
                            }}
                          ></div>

                          {/* Centered Progress Bar */}
                          <div
                            style={{
                              position: 'fixed',
                              top: '50%',
                              left: '50%',
                              transform: 'translate(-50%, -50%)', // Center the element
                              backgroundColor: '#FFFFFF',
                              zIndex: 9999,
                              textAlign: 'center',
                              padding: '20px',
                              borderRadius: '8px',
                              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                              width: '300px', // Adjust width for better alignment
                            }}
                          >
                            <Progress
                              percent={csvProgress}
                              status={csvProgress < 100 ? 'active' : 'success'}
                              strokeColor="#1C4E9D"
                              style={{ width: '100%' }} // Full width inside the container
                            />
                            <p
                              style={{
                                margin: '10px 0 0',
                                color: '#1C4E9D',
                                fontSize: '16px',
                              }}
                            >
                              Processing...
                            </p>
                            <p
                              style={{
                                marginTop: '5px',
                                color: '#344054',
                                fontSize: '14px',
                              }}
                            >
                              Generating optimized results...
                            </p>
                          </div>
                        </>
                      )}

                      {/* {bbsAlgorithmLoading && (
                        <>
                        
                          <div
                            style={{
                              position: 'fixed',
                              top: 0,
                              left: 0,
                              width: '100%',
                              height: '100%',
                              backgroundColor: 'rgba(0, 0, 0, 0.5)', // Semi-transparent black
                              zIndex: 9998, // Lower than the progress bar container
                            }}
                          ></div>

                        
                          <div
                            style={{
                              position: 'fixed',
                              bottom: 0,
                              left: 0,
                              width: '100%',
                              backgroundColor: '#FFFFFF',
                              zIndex: 9999, // Higher than the overlay
                              textAlign: 'center',
                              padding: '10px 0',
                              display: 'flex', // Use flexbox for layout
                              justifyContent: 'center', // Center the bars
                              gap: '20px', // Optional: Adds spacing between the bars
                            }}
                          >
                           
                            <div style={{ width: '45%' }}>
                              <Progress
                                percent={progressTaskOne}
                                status={progressTaskOne < 100 ? 'active' : 'success'}
                                strokeColor="#1C4E9D"
                                style={{ width: '100%' }}
                              />
                              <p style={{ marginTop: '5px', color: '#344054', fontSize: '14px' }}>
                                Files are getting Optimized...
                              </p>
                            </div>

                            {progressTaskOne >= 100 && (
                              <div style={{ width: '45%' }}>
                                <Progress
                                  percent={progressTaskTwo}
                                  status={progressTaskTwo < 100 ? 'active' : 'success'}
                                  strokeColor="#1C4E9D"
                                  style={{ width: '100%' }}
                                />
                                <p style={{ marginTop: '5px', color: '#344054', fontSize: '14px' }}>
                                  BBS Optimized sheet is getting prepared...
                                </p>
                              </div>
                            )}
                          </div>
                        </>
                      )} */}
                      {bbsCurrentStep === 3 && (
                        <>
                          <VisualizationTable
                            bbsAlgorithmResult={bbsAlgorithmResult}
                            optimizationDate={optimizationDate}
                          />
                        </>
                      )}
                    </div>
                    {bbsCurrentStep === 3 && (
                      <div className="flex justify-center mt-4">
                        <Button
                          style={{ margin: '0 8px' }}
                          onClick={() => navigate('/dashboard')}
                          className="prev-button"
                        >
                          Back to Dashboard
                        </Button>
                        <Button
                          onClick={() =>
                            downloadMappingSheet(
                              optimizedResponseData?.bbs_id || bbsData?.bbs_id,
                            )
                          }
                          className="custom-vis-btn bg-[#1C4E9D] text-[#FFFFFF] font-['SF-Pro-Text-Regular, sans-serif'] text-[14px] hover:text-[#1C4E9D] hover:bg-[#FFFFFF]"
                        >
                          Download Mapping Sheet
                        </Button>
                        <Button
                          style={{ margin: '0 8px' }}
                          type="primary"
                          onClick={nextStep}
                          className="next-button"
                        >
                          Next
                        </Button>
                      </div>
                    )}

                    {bbsCurrentStep === steps?.length - 1 && (
                      <div className="flex justify-center mt-4">
                        <Button
                          style={{ margin: '0 8px' }}
                          onClick={() => navigate('/dashboard')}
                          className="prev-button"
                        >
                          Back to Dashboard
                        </Button>
                      </div>
                    )}
                  </Card>
                </div>
              </div>
            </Col>
          </div>
        </Row>
      </div>
    </div>
  );
};

export default BbsOptimization;
